export enum BillingPlanGroup {
    Free = 'free',
    Start = 'start',
    Pro = 'pro',
    Scale = 'scale',
}
